import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MegaMenu = _resolveComponent("MegaMenu")

  return (_openBlock(), _createBlock("nav", {
    id: "sidebarMenu",
    class: ["sidebar-main", { 'is--expanded': _ctx.isSidebarExpanded }]
  }, [
    _createVNode(_component_MegaMenu, {
      model: _ctx.menuItemsContextual,
      orientation: "vertical",
      class: "sidebar-main__menu-contextual"
    }, null, 8, ["model"])
  ], 2))
}